import React from 'react'

import { Box, Flex, GatsbyImage, Link } from 'system'
import { BoundedBox } from 'src/components/BoundedBox'
import { ButtonArrow } from 'src/components/ButtonArrow'
import { ContactInfo } from 'src/components/ContactInfo'
import { Heading } from 'src/components/Heading'
import { MarkdownContent } from 'src/components/MarkdownContent'
import { Subheading } from 'src/components/Subheading'

const Affiliate = ({
  imageFluid,
  name,
  descriptionMarkdown,
  url,
  addressMarkdown,
  faxNumber,
  phoneNumber,
  ...props
}) => (
  <Box flex="1 1 0px" mb={[6, 0]} mr={[null, 4]} boxStyle="lastNoMargin">
    {imageFluid && (
      <Flex alignItems="center" minHeight={[null, '6rem']} mb={[3, 2]}>
        <GatsbyImage fluid={imageFluid} alt={name} width="8rem" />
      </Flex>
    )}
    <Subheading mb={2}>{name}</Subheading>
    {descriptionMarkdown && (
      <MarkdownContent markdown={descriptionMarkdown} mb={3} />
    )}
    {phoneNumber && (
      <ContactInfo type="phone" mb={2}>
        {phoneNumber}
      </ContactInfo>
    )}
    {faxNumber && (
      <ContactInfo type="fax" mb={2}>
        {faxNumber}
      </ContactInfo>
    )}
    {url && (
      <ContactInfo type="website" mb={2}>
        <Link to={url} target="_blank" rel="noopener noreferrer">
          {url}
        </Link>
      </ContactInfo>
    )}
    {addressMarkdown && (
      <ContactInfo type="address">
        <MarkdownContent markdown={addressMarkdown} lineHeight="copy" />
      </ContactInfo>
    )}
    {url && (
      <ButtonArrow to={url} target="_blank" rel="noopener noreferrer" mt={3}>
        Learn More
      </ButtonArrow>
    )}
  </Box>
)

export const Affiliates = ({ children, heading, ...props }) => (
  <BoundedBox as="section" maxWidth="large" {...props}>
    {heading && (
      <Heading mb={4} textAlign="center">
        {heading}
      </Heading>
    )}
    <Flex flexDirection={['column', 'row']} justifyContent="center">
      {children}
    </Flex>
  </BoundedBox>
)

Affiliates.Affiliate = Affiliate
